import { placeholderAvatar as avatar } from '../constants';
export default [
    {
        id: 0,
        avatar: avatar,
        creatorName: 'John Doe',
        litterCount: '26',
        date: '04 March 2020',
        duration: '24 mins',
        distance: '10 m',
        mapContent: null,
        tagsContent: null,
        isActive: true,
    },
    {
        id: 1,
        avatar: avatar,
        creatorName: 'Christopher Walker',
        litterCount: '52',
        date: '14 March 2020',
        duration: '1 hr 6 mins',
        distance: '31 m',
        mapContent: null,
        tagsContent: null,
    },
];
